<template>
<div class=" row text-primary">
        <div class="col-12 text-center">
            <loading-round dot-background="rgb( 57,84,164 )"/>
            <div class="mt-3">Please wait . . .</div>
        </div>
    </div>
</template>

<script>
import urls from '../../data/urls';
import axios from 'secure-axios';

export default {
    name: 'Logout',
    data () {
        return {
            URL: urls.auth.Logout
        };
    },
    beforeMount () {
        this.logout();
    },
    methods: {
        async logout () {
            await axios.post(this.URL);
            sessionStorage.clear();
            await this.$router.push({ path: '/login/' }).then(() => {
                window.location.reload(true);
            });
        }
    }
};
</script>

<style scoped>

</style>
